<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="back()"><ion-icon name="arrow-back-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title>Edit position</ion-title>
    <ion-buttons slot="end">
      <ion-button color="danger" fill="clear" (click)="delete()">delete</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form (ngSubmit)="save()">
    <ion-list>
      <ion-item>
        <ion-label>
          <p>Zone</p>
          <h3>{{ zone?.name }}</h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>
          <p>Level</p>
          <h3>{{ level?.name || 'No level' }}</h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>
          <p>Group</p>
          <h3>{{ group?.name }}</h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <app-device-input
          [error]="error"
          (newDevice)="newDevice($event)"
          (calibrationStatus)="calibrationStatus($event)"
        ></app-device-input>
      </ion-item>
      <ion-item>
        <ion-input
          type="text"
          autocomplete="off"
          [(ngModel)]="customId"
          [ngModelOptions]="{standalone: true}"
          (click)="blurInput()"
          label="Custom ID"
          labelPlacement="floating"
          placeholder=""
        ></ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          type="text"
          autocomplete="off"
          [value]="networkId"
          [ngModelOptions]="{standalone: true}"
          disabled
          label="Network ID"
          labelPlacement="floating"
          placeholder=""
        ></ion-input>
      </ion-item>
      <ion-item>
        <app-labels-select></app-labels-select>
      </ion-item>
    </ion-list>
    <button type="submit" style="display:none">hidden submit hack</button>
  </form>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-button expand="full" (click)="save()">save</ion-button>
  </ion-toolbar>
</ion-footer>
